import { storeInstance } from './../../store.js';
import * as types from '../NGUD/types';
import Message from '@/components/shared/mixins/Message.js';
import Const from '@/components/shared/helpers/Const.js';

const state = {
  ODSObjetives: [],
  ODSciudadSelected: []
};

const getters = {
  [types.ALL_ODSOBJETIVOS]: state => {
    return state.ODSObjetivos;
  },
  [types.ODSOBJETIVO_CIUDAD]: state => {
    return state.ODSCiudadSelected;
  }
};

const mutations = {
  [types.MUTATE_ALL_ODSOBJETIVOS]: (state, payload) => {
    state.ODSObjetivos = payload;
  },
  [types.MUTATE_ODSOBJETIVO_CIUDAD]: (state, payload) => {
    state.ODSCiudadSelected = payload;
  }
};

const actions = {
  [types.ACTION_GET_ALL_ODSOBJETIVOS]: ({ commit }) => {
    let request = { controller: `/Objetivo/${Const.ID_ODS}` };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          commit(types.MUTATE_ALL_ODSOBJETIVOS, response.data);
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_ODSOBJETIVO_CIUDAD]: ({ commit, getters }) => {
    let ciudadId = getters['NGUD/ciudadData'].id;
    let request = { controller: `/CiudadIndice/${ciudadId}/${Const.ID_ODS}` };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          commit(types.MUTATE_ODSOBJETIVO_CIUDAD, response.data.objetivos);
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_SAVE_ODSOBJETIVO_CIUDAD]: ({ commit, getters }, payload) => {
    let ciudadId = getters['NGUD/ciudadData'].id;
    let parseData = {
      objetivos: payload.data
    };

    let request = {
      controller: `/CiudadIndice/${ciudadId}/${Const.ID_ODS}`,
      filter: {},
      body: parseData
    };

    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/postSuit', request)
        .then(response => {
          // commit(types.MUTATE_ODSOBJETIVO_CIUDAD, response.data.objetivos);
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_OBJETIVOS_ESPECIFICOS]: ({ commit }, payload) => {
    let request = { controller: '/Objetivo/' + payload.idObjetivo + '/ObjetivosEspecificos' };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },

  [types.ACTION_GET_OBJETIVOS_ESPECIFICOS_LINEAS_ACTUACION]: ({ commit }, payload) => {
    let request = { controller: '/ObjetivoEspecifico/' + payload.idObjetivo + '/LineasDeActuacion' };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  }
};

export default {
  actions,
  state,
  getters,
  mutations
};
